import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ConnectedPageWithTable } from './../root_classes/connected-page-with-table';
import { ConstantsModule } from './../constants/constants.module';
import { HttpClient } from '@angular/common/http';
import { FolderAddComponent } from '../folder-add/folder-add.component';
import { FolderEditComponent } from '../folder-edit/folder-edit.component';
import { FolderEditRightsComponent } from '../folder-edit-rights/folder-edit-rights.component';
import { FolderEditMailComponent } from '../folder-edit-mail/folder-edit-mail.component';
import { FolderReminderComponent } from './../folder-reminder/folder-reminder.component';
import { FolderUpdaterComponent } from './../folder-updater/folder-updater.component';
import { FolderRestartComponent } from '../folder-restart/folder-restart.component';
import { FolderStartComponent } from '../folder-start/folder-start.component';


@Component({
	selector: 'app-folder-list',
	templateUrl: './folder-list.component.html',
	styleUrls: ['./folder-list.component.scss']
})
export class FolderListComponent extends ConnectedPageWithTable implements OnInit {

	public stateChoice: any[] = [];

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);

		// Creating filter list.
		this.stateChoice = [
			{label: "En attente", value:'D'},
			{label: "En cours", value:'R'},
			{label: "Terminé", value:'E'},
			{label: "Désactivé", value:'X'}
		];
	}

	ngOnInit(): void {
		this.setColumns([
			{field:"name", header:"Nom", sort:"name"},
			{field:"state", header:"Etat", sort:"state"},
			{field:"path", header:"Chemin", sort:"path"},
			{field:"endDateVal", header:"Date d'arrêt", sort:"endDateVal"},
		]);

		// Loadint data from the server.
		this.loadData("/api/folder-list");
	}

	public doAdd(): void {
		this.runModalDialog(FolderAddComponent,
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur de base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter le dossier: Le dossier existe déjà.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
					case "INVALID DATE":
						this.alertLine.alertDangerMessage = "Date d'arrêt saisie invalide : veuillez saisir une date d'arrêt postérieur à celle du jour.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside or press space bar the dialog.
				if (reason != 1 && reason != 0) {
					// Inserting new item inside the list.
					var newFolder = {
						"_id": reason["_id"],
						"name": reason["name"],
						"path": reason["path"],
						"endDate": reason["endDate"],
						"endDateVal": reason["endDateVal"],
						"state": "D",
					};

					// Updating for sorting.
					this.datas = [ ...this.datas, newFolder ];

					// Updating the sorting.
					this.filterData();

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Dossier ajouté.";
				}
			}
		);
	}

	public doEdit(folderName: string, folderId: string, folderEndDate: Date): void {
		this.runModalDialogWithParameters(FolderEditComponent, {name: folderName, id: folderId, endDate: folderEndDate},
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dossier à renommer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Un dossier porte déjà le nom demandé. Opération annulée.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					case "INVALID DATE":
						this.alertLine.alertDangerMessage = "Date d'arrêt saisie invalide : veuillez saisir une date d'arrêt postérieur à celle du jour.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {
					for(var folderIndex in this.getData()) {
						var folder = this.getDataItem(folderIndex);
						if (folder._id == reason.id) {
							folder.name = reason.name;
							folder.path = reason.path;
							folder.endDate = reason.endDate;
							folder.endDateVal = reason.endDateVal;
							break;
						}
					}

					// Updating the sorting.
					this.filterData();

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Dossier modifié.";
				}
			}
		);
	}

	public doEditMail(folderId:string, folderName:string): void {
		this.runModalDialogWithParameters(FolderEditMailComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dosser à mettre à jour. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de donénes. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Email modifié.";
				}
			}
		);
	}

	public doSendReminder(folderId:string, folderName:string): void {
		this.runModalDialogWithParameters(FolderReminderComponent, {id:folderId, name:folderName},
			(result:any) => {
				// Nothing.
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					if (reason.DATA == "OK") {
						this.alertLine.alertSuccessMessage = "Emails de rappel envoyés (Nombre: " + reason.NB + ").";
					} else {
						this.alertLine.alertDangerMessage = "Impossible d'envoyer les emails de rappel. Contactez votre administrateur.";
					}
				}
			}
		);
	}

	public doSendForUpdate(folderId:string): void {
		this.runModalDialogWithParameters(FolderUpdaterComponent, {id:folderId},
			(result:any) => {
				// Nothing.
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) { 
					if (reason.DATA == "OK") {
						this.alertLine.alertSuccessMessage = "Emails de rappel envoyés (Nombre: " + reason.NB + ").";
					} else {
						this.alertLine.alertDangerMessage = "Impossible d'envoyer les emails de rappel. Contactez votre administrateur.";
					}
				}
			}
		);
	}

	public doEditRights(folderName: string, folderId: string): void {
		this.runModalDialogWithParameters(FolderEditRightsComponent, {name: folderName, id: folderId},
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dossier à renommer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Droits du dossier modifié.";
				}
			}
		);
	}

	public doStart(folderId: string, folderName: string): void {
		this.runModalDialogWithParameters(FolderStartComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de démarrer le dossier.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Dossier démarré.";

					// Replacing the state on the list.
					for(var folderIndex in this.getData()) {
						var folder = this.getDataItem(folderIndex);
						if (folder._id == folderId) {
							folder.state = "R";
							break;
						}
					}

					// Fitering again datas.
					this.filterData();
				}
			}
		);
	}

	public doDeactivate(folderId: string): void {
		// Sending stoping to the server.
		var newData = {
			"folderid": folderId
		};
		this.put("/api/folder-deactivate", newData,
				(response: any) => {
					this.alertLine.alertSuccessMessage = "Dossier désactivé.";
				},
				(err: any) => {
					this.alertLine.alertDangerMessage = "Impossible de désactiver la dossier.";
				});

		// Replacing the state on the list.
		for(var folderIndex in this.getData()) {
			var folder = this.getDataItem(folderIndex);
			if (folder._id == folderId) {
				folder.state = "X";
				break;
			}
		}

		// Filtering again datas.
		this.filterData();
	}

	public doActivate(folderId: string): void {
		// Sending stoping to the server.
		var newData = {
			"folderid": folderId
		};
		this.put("/api/folder-activate", newData,
			(response: any) => {
				this.alertLine.alertSuccessMessage = "Dossier activé.";
				// Replacing the state on the list.
				for(var folderIndex in this.getData()) {
					var folder = this.getDataItem(folderIndex);
					if (folder._id == folderId) {
						folder.state = response.RES;
						break;
					}
				}
		
				// Filtering again datas.
				this.filterData();
			},
			(err: any) => {
				this.alertLine.alertDangerMessage = "Impossible d'activer la dossier.";
		});
	}

	public filterColumns(event: Event): string {
		return (<HTMLInputElement> event.target).value;
	}

	public doRestart(folderId: string, folderName: string): void {
		this.runModalDialogWithParameters(FolderRestartComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de redémarrer le dossier.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Dossier redémarré.";

					// Replacing the state on the list.
					for(var folderIndex in this.getData()) {
						var folder = this.getDataItem(folderIndex);
						if (folder._id == folderId) {
							folder.state = "R";
							folder.endDate = reason.endDate;
							folder.endDateVal = reason.endDateVal;
							break;
						}
					}

					// Fitering again datas.
					this.filterData();
				}
			}
		);
	}
}
